module.exports = __webpack_public_path__ + "media/images/icons/flags/LV-3709fe685e4c93386e1bc35a617de1c2.svg";